var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 16 17",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8 14.1993 3.8799 2.4554c.7105.45 1.58-.2152 1.393-1.0565l-1.0284-4.6173 3.4311-3.11083c.6264-.56738.2898-1.64345-.5329-1.71193l-4.5156-.40108-1.76698-4.36297c-.31787-.79238-1.40237-.79238-1.72024 0l-1.76698 4.35319-4.515626.40108c-.822722.06848-1.15929 1.14455-.532899 1.71193l3.431125 3.11081-1.0284 4.6173c-.18698.8413.68248 1.5065 1.39302 1.0565z",
    fill: "#ffb547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFull);
export default __webpack_public_path__ + "static/media/star-full.4b8834ffa2114f5f54942137f8895449.svg";
export { ForwardRef as ReactComponent };